import React, { useEffect, useRef } from "react";
import { MagnifyingGlass, X } from "@phosphor-icons/react";
import "./mobile-catalog-search.css";

const MobileCatalogSearch = ({ value, onChange, placeholder }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (window.matchMedia("(min-width: 992px)").matches) onChange("");
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [onChange]);

  return (
    <div className="mobile-catalog-search">
      <div className="mobile-catalog-search__container">
        <form role="search" className="mobile-catalog-search__field" onSubmit={(event) => event.preventDefault()}>
          <MagnifyingGlass size={20} aria-hidden="true" />
          <input ref={inputRef} type="search" value={value} onChange={(event) => onChange(event.target.value)}
            placeholder={placeholder} aria-label={placeholder} />
          {value && (
            <button type="button" aria-label="Clear search" onClick={() => {
              onChange("");
              inputRef.current?.focus();
            }}><X size={18} aria-hidden="true" /></button>
          )}
        </form>
      </div>
    </div>
  );
};

export default MobileCatalogSearch;
